import {
  ORG_ADMIN,
  ORG_EMPLOYEE,
  ORG_SUPER_ADMIN,
  DEVELOPER,
  DEV_OPS,
  UI_UX_DESIGNER,
  BUSINESS_ANALYST,
  PROJECT_MANAGER,
  TESTER,
  APP_SUPER_ADMIN,
} from './keys';

export const projectStatus = {
  1: 'NEW',
  2: 'IN_PROGRESS',
  3: 'COMPLETED',
  4: 'ARCHIVED',
} as const;

export const UserStoryStatus = {
  1: 'New',
  2: 'In progress',
  3: 'Completed',
} as const;

export const userRole = {
  [APP_SUPER_ADMIN]: 1,
  [ORG_SUPER_ADMIN]: 2,
  [ORG_ADMIN]: 3,
  [ORG_EMPLOYEE]: 4,
} as const;

export const userDesignation = {
  [DEVELOPER]: 1,
  [BUSINESS_ANALYST]: 2,
  [PROJECT_MANAGER]: 3,
  [TESTER]: 4,
  [UI_UX_DESIGNER]: 5,
  [DEV_OPS]: 6,
};

export const searchResponse = {
  1: 'employee',
  2: 'project',
  3: 'user_story',
} as const;
